<template>
  <div>
    <top-nav></top-nav>
    <div v-loading="Loading" class="center_container">
      <div class="crumb">首页 / 场馆预定 / 场馆详情</div>

      <div class="top_info">
        <div class="i_left">
          <!-- height="620px" -->
          <el-carousel class="carousel" indicator-position="none">
            <el-carousel-item v-for="(item,index) in imageChange(detailData.pics)" :key="'pic'+index"
                              class="carousel_item">
              <div class="c_con">
                <img :src="fileUrl+item" alt="" class="i_img">
                <!--                <img alt="" class="i_vr" src="../../assets/image/venue/vr.png" @click="toVrUrl">-->
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="i_right">
          <div class="display_flex r_name">
            {{ detailData.name || '-' }}
            <!--            <span>国营</span>-->
          </div>
          <div class="r_i" style="margin-bottom: 13px">
            <img alt="" src="../../assets/image/venue/icon_local.png">
            <span>{{ detailData.address || '-' }}</span>
            <el-button type="primary" @click="dhBtn">导航</el-button>
          </div>
          <div class="r_i">
            <img alt="" src="../../assets/image/venue/icon_tel.png">
            <span>{{ detailData.telephone || '-' }}</span>
          </div>
          <div class="r_i">
            <img alt="" src="../../assets/image/venue/icon_time.png">
            <span>{{ detailData.openStartTime ? detailData.openStartTime + '-' + detailData.openEndTime : '-' }}</span>
          </div>
          <div class="r_i">
            <img alt="" src="../../assets/image/venue/icon_sb.png">
            <span>{{ detailData.facilities || '-' }}</span>
          </div>
          <div class="r_i">
            <img alt="" src="../../assets/image/venue/icon_fw.png">
            <span>{{ detailData.services || '-' }}</span>
          </div>
          <div class="map_title">地理位置</div>
          <div class="geography_style">
            <baidu-map :center="{lng:detailData.lon, lat: detailData.lat}" :dragging="true"
                       :map-click="false" :scroll-wheel-zoom="true"
                       :zoom="10"
                       class="map"
                       @ready="handleReady">
              <bm-marker
                  :icon="{url: require('@/assets/image/index/icon_local.png'), size: { width: 74, height: 88 }}"
                  :position="{lng: detailData.lon, lat: detailData.lat}"
              >
              </bm-marker>

            </baidu-map>
          </div>

          <!--          <img alt="" class="map_img" src="../../assets/image/venue/map_img.png">-->
        </div>
      </div>

      <el-tabs v-model="activeName">
        <el-tab-pane label="订场须知" name="1"></el-tab-pane>
        <el-tab-pane label="场馆介绍" name="2"></el-tab-pane>
        <!--        <el-tab-pane label="公告（8）" name="3"></el-tab-pane>-->
        <!--        <el-tab-pane label="评价（432）" name="4"></el-tab-pane>-->
      </el-tabs>

      <div class="i_con">
        <div v-show="activeName === '1'">
          <div v-html="detailData.bookingNotice"></div>
        </div>
        <div v-show="activeName === '2'" v-html="detailData.description"></div>
        <!--        <div v-show="activeName === '3'">-->
        <!--          <div class="display_flex gg_item" v-for="(item, index) in 8" :key="index">-->
        <!--            <div class="text_overflow" style="margin-right: 40px">【场馆动态】“我为妇女群众办实事”——“暖心服务周”主题活动，免费羽毛球、健身等你来！</div>-->
        <!--            <div>2023-08-23 09:00</div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div v-show="activeName === '4'">-->
        <!--          <div v-for="item in 4" :key="item" class="pj_item">-->
        <!--            <div class="pj_name">会员23987864</div>-->
        <!--            <el-rate-->
        <!--                :value="5"-->
        <!--                disabled style="margin: 5px 0"-->
        <!--                text-color="#F4C41D">-->
        <!--            </el-rate>-->
        <!--            <div>-->
        <!--              非常好的场馆非常好的场馆非常好的场馆非常好的场馆非常好的场馆非常好的场馆，非常好的场馆非常好的场馆非常好的场馆非常好的场馆，非常好的场馆非常好的场馆非常好的场馆非常好的场馆非常好的场馆，非常-->
        <!--              好的场馆非常好的场馆，非常好的场馆非常好的场馆。-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="display_flex" style="justify-content: center;margin-top: 30px">-->
        <!--            <el-pagination-->
        <!--                :total="100"-->
        <!--                background-->
        <!--                layout="prev, pager, next">-->
        <!--            </el-pagination>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>

      <div class="display_flex xm">
        <div class="xm_t">场馆项目</div>
        <div class="xm_r">
          <div v-for="(item, index) in venueData" :key="'xm'+index" :class="{'sel_xm': currentXmIndex === item.id}"
               class="display_flex xm_i" @click="projectClick(item)">
            <div class="img_block">
              <img :src="fileUrl+item.imageUrl" alt="">
            </div>

            <div class="item_block">{{ item.projectName }}</div>
          </div>
        </div>
      </div>

      <div class="xm_title">项目介绍</div>
      <div class="xm_js">{{ currentXm && currentXm.introduce }}</div>

      <div class="xm_title">场地预约</div>
      <div class="display_flex rq">
        <div class="rq_t">日期：</div>
        <div class="display_flex rq_list">
          <div v-for="(item, index) in dateList" :key="index"
               :class="{'sel_date': currentDateIndex === item.dayWeek}" class="date_item"
               @click="dateClick(item)">
            {{ item.date | dateFilter }} （{{ item.week }}）
          </div>
        </div>
      </div>

      <div class="cd">
        <div class="cd_left">
          <div class="cd_list">
            <div class="cd_item t_item"></div>
            <div v-for="item in siteList.length && siteList[0].dateList" class="cd_item">{{ item.startTime }}</div>
          </div>
          <div v-for="(item, i) in siteList" :key="i" class="cd_list r_list">
            <div class="cd_item t_item">{{ item.siteChildName }}</div>
            <div v-for="(date, di) in item.dateList" :key="i + '-' + di"
                 :class="{'kx_item': date.selectFlg === 0, 'sel_item': selSiteDateId.indexOf(i + '-' + di) > -1}"
                 class="cd_item date_item" @click="selSite(item, i, date, di)">
              <span v-if="date.selectFlg === 0">￥{{ date.price }}</span>
            </div>
          </div>
        </div>
        <div class="cd_right">
          <div class="display_flex ts">
            <div class="display_flex"><span style="background: #FFFFFF;border: 1px solid #B0B0B0;"></span>可选择</div>
            <div class="display_flex"><span style="background: #E1E1E1"></span>不可选择</div>
            <div class="display_flex"><span style="background: #0058A6"></span>已选择</div>
          </div>
          <div class="js">
            <div>场地类型：{{ currentXmName }}</div>
            <div style="margin: 24px 0">预约时间：{{ currentDateName }}
            </div>
            <div>已选场次：{{ selectedSessions.length }}</div>
          </div>
          <div class="sel_cc">
            <div v-for="(item, index) in selectedSessions" :key="index"
                 class="display_flex cc_item">
              <div>{{ item.siteChildName }}</div>
              <div>{{ item.startTime }}-{{ item.endTime }}</div>
              <div>￥{{ item.price.toFixed(2) }}</div>
              <i class="el-icon-error" @click="delSelSession(index)"></i>
            </div>
            <div class="hj">
              合计
              <div>￥<span>{{ totalMoney.toFixed(2) }}</span></div>
            </div>
          </div>
          <div style="text-align: center">
            <el-button :disabled="selectedSessions.length===0" class="sub_btn" type="primary" @click="submitClick">
              提交订单
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="导航" width="954px">
      <div class="dialog_content">
        <baidu-map :center="{lng: 123.429096, lat: 41.796767}" :dragging="true"
                   :map-click="false" :scroll-wheel-zoom="true"
                   :zoom="zoom"
                   class="map"
                   @ready="handleReady">

          <bm-driving
              v-if="end"
              :auto-viewport="true"
              :end="end"
              :panel="false"
              :start="start"
          >
          </bm-driving>

        </baidu-map>
      </div>

    </el-dialog>
    <bot-nav></bot-nav>
  </div>
</template>

<script>
import { getToken, removeToken } from "../../utils/auth";
import moment from 'moment'
import { FILE_API } from "@/Settings"
import router from '@/router'

export default {
  name: "venueDetail",
  data () {
    return {
      fileUrl: FILE_API,
      BMap: null,
      map: null,
      zoom: 13, // 地图初始放大倍数
      pointList: [
        {
          lng: 123.429096,
          lat: 41.796767,
          type: 'cg',
          title: '沈河区体育馆',
          xm: '篮球、乒乓球',
          time: '09:00-20:00',
          add: '辽宁省沈阳市浑南区航天路26号'
        },
        {
          lng: 123.409096,
          lat: 41.786767,
          type: 'cd',
          title: '室外体育场',
          xm: '篮球、足球、羽毛球',
          time: '09:00-20:00',
          add: '辽宁省沈阳市浑南区航天路26号'
        }
      ],
      end: null,

      start: { lng: 123.463623, lat: 41.723834 },
      dialogVisible: false,
      detailData: {},
      activeName: '1',
      xm: [
        { name: '足球', img: 'zq' },
        { name: '排球', img: 'pq' },
        { name: '乒乓球', img: 'ppq' },
        { name: '篮球', img: 'lq' },
        { name: '网球', img: 'wq' }
      ],
      currentXm: null,
      currentXmIndex: 0,

      dateList: [],
      currentDateIndex: 0,

      // 场地
      siteList: [],
      // 已选场次
      selectedSessions: [],
      selSiteDateId: [],
      totalMoney: 0,
      venueData: [],
      siteName: '',
      currentXmName: '',
      currentDateName: '',
      currentXmSiteName: '',//场地名称
      Loading: true
    }
  },
  filters: {
    dateFilter (val) {
      return moment(val).format('MM月DD日')
    },
    allDateFilter (val) {
      return moment(val).format('YYYY年MM月DD日')
    }
  },
  mounted () {
    // this.detailData = JSON.parse(this.$route.query.item)

    for (let i = 0; i < 7; i++) {
      let currentDate = moment().format('YYYY-MM-DD');
      let date = moment().add(i, 'days').format('YYYY-MM-DD');
      this.dateList.push({
        date,
        week: currentDate === date ? '今天' : this.getWeek(date),
        dayWeek: moment(date).day() || 7
      })
    }
    this.currentDateIndex = this.dateList[0].dayWeek
    this.currentDateName = moment().add(0, 'days').format('YYYY年MM月DD日')
  },
  created () {
    this.detailAjax()
    this.geolocation()
  },
  methods: {
    /**
     * 浏览器定位函数
     */
    geolocation () {
      var that = this;
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function(res) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          that.start = res.point
        } else {
          console.log('failed' + this.getStatus()); //失败时，弹出失败状态码
        }
      }, { enableHighAccuracy: true }) //enableHighAccuracy：是否要求浏览器获取最佳效果，默认为false
    },
    submitClick () {
      if (!getToken()) {
        this.$confirm('未登录或登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning'
            }
        ).then(() => {
          removeToken()
          router.push({ path: '/login' })
        }).catch(() => {
        });
        return
      }
      this.$postAction('gateway/venue-order/add', {
        venueId: this.$route.query.id,
        memberId: localStorage.getItem('memberId'),
        projectName: this.currentXmName,
        predetermineDate: this.predetermineDate,
        totalAmount: this.totalMoney,
        venueName: this.detailData.name, //场馆名称
        siteName: this.currentXmSiteName,  //场地名称
        childOrderList: this.selectedSessions
      }).then((res) => {
        if (res.code === 0) {
          this.$message.success('提交成功')
          this.selectedSessions = []
          this.selSiteDateId = []
          this.totalMoney = 0
          this.venueAjax()
        } else {
          this.$message.error(res.msg)
        }

      })
    },
    imageChange (url) {
      let imgList = url && url.split(',')
      return imgList || []
    },
    dateClick (item) {
      this.currentDateIndex = item.dayWeek
      this.predetermineDate = item.date
      this.selSiteDateId = []
      this.selectedSessions = []
      // moment().add(i, 'days').format('YYYY-MM-DD');
      this.currentDateName = moment(item.date).format('YYYY年MM月DD日')
      this.venueAjax()
    },
    projectClick (item) {
      this.currentXm = item
      this.currentXmIndex = item.id
      this.currentXmName = item.projectName
      this.currentXmSiteName = item.name

      this.venueAjax()
    },
    // 获取场馆详情
    detailAjax () {
      this.$postAction('gateway/venue-info/detail', {
        venueId: this.$route.query.id
      }).then((res) => {
        this.detailData = res.data
        this.$nextTick(() => {
          this.Loading = false
        })

      })
      this.$postAction('gateway/site/listByVenueId', {
        venueId: this.$route.query.id
      }).then((res) => {
        this.venueData = res.data
        let list = []
        this.venueData.forEach((val) => {
          list.push(val.projectName)

        })
        this.siteName = list.toString()
        this.currentXm = this.venueData[0]
        this.currentXmIndex = this.venueData[0].id
        this.currentXmName = this.venueData[0].projectName
        this.currentXmSiteName = this.venueData[0].name
        this.venueAjax()
      })
    },
    // 场地预约
    venueAjax () {
      this.$postAction('gateway/site/venueSubscribeList', {
        // siteId:1,
        siteId: this.currentXmIndex,
        week: this.currentDateIndex,
        predetermineDate: this.predetermineDate
      }).then((res) => {
        this.siteList = res.data
      })
    },
    handleReady ({ BMap, map }) {
      this.BMap = BMap
      this.map = map

      // BMAP_SATELLITE_MAP 卫星地图  BMAP_HYBRID_MAP 混合地图  BMAP_NORMAL_MAP 普通地图
    },
    getWeek (date) { // 参数时间戳
      let week = moment(date).day()
      switch (week) {
        case 1:
          return '周一'
        case 2:
          return '周二'
        case 3:
          return '周三'
        case 4:
          return '周四'
        case 5:
          return '周五'
        case 6:
          return '周六'
        case 0:
          return '周日'
      }
    },

    // 导航
    dhBtn () {
      this.end = { lng: this.detailData.lon, lat: this.detailData.lat }
      this.dialogVisible = true
    },

    toVrUrl () {
      window.open('https://www.720yun.com/vr/81ajOgewrk8', '_target')
    },

    /**
     * 选择场次
     * @param item 场次数据
     * @param i 选中场次下标
     * @param date 选中场次下的时间
     * @param di 选中场次下的选中时间的下标
     */
    selSite (item, i, date, di) {
      // data.status为1时是不可选择状态
      if (date.selectFlg !== 0) return
      let sIndex = this.selSiteDateId.indexOf(i + '-' + di)
      if (sIndex > -1) {
        this.delSelSession(sIndex)
        return
      }
      console.log(item)

      this.totalMoney = 0
      this.selectedSessions.push({
        ...item,
        ...date,
        id: item.id,
        dId: date.id,
        orderPrice: date.price, //价格
        venueName: this.detailData.name, //场馆名称
        siteName: this.currentXmSiteName,  //场地名称
        venueReservation: item.siteChildName,  //预定场地
        scheduledTime: date.startTime + '-' + date.endTime, //预定时间段
        predetermineDate: this.predetermineDate, //预定时间
        siteChildTimeAndPriceSettingId: date.siteChildTimeAndPriceSettingId //子场地时间和价格的设置id
      })
      this.selSiteDateId.push(i + '-' + di)
      this.getTotalMoney()
    },

    // 删除选中场次
    delSelSession (index) {
      this.selectedSessions.splice(index, 1)
      this.selSiteDateId.splice(index, 1)
      this.getTotalMoney()
    },

    // 获取合计
    getTotalMoney () {
      this.totalMoney = 0
      this.selectedSessions.forEach(item => {
        this.totalMoney += item.price
      })
    }
  }
}
</script>

<style lang="less" scoped>
.center_container {
  .top_info {
    display: flex;
    margin-bottom: 50px;

    .i_left {
      width: 60%;

      .carousel {
        height: 100%;

        .carousel_item {
          height: 100%;

          .c_con {
            height: 100%;
            position: relative;

            .i_img {
              width: 100%;
              height: 100%;
            }

            .i_vr {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              cursor: pointer;
            }
          }
        }
      }
    }

    .i_right {
      width: 40%;
      padding-left: 50px;
      font-size: 16px;

      .r_name {
        font-weight: 700;
        font-size: 36px;
        justify-content: start;
        margin-bottom: 35px;

        span {
          font-weight: 500;
          font-size: 20px;
          color: #FFFFFF;
          padding: 8px 17px;
          background: #D23838;
          border-radius: 2px;
          margin-left: 20px;
        }
      }

      .r_i {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        img {
          margin-right: 9px;
        }

        span {
          flex: 1;
        }
      }

      .map_title {
        margin: 50px 0 16px;
        font-weight: 500;
        font-size: 18px;
        color: #0058A6;
      }

      .map_img {
        width: 100%;
      }
    }
  }

  .i_con {
    padding: 30px 0 80px;
    font-size: 18px;
    line-height: 32px;

    .gg_item {
      font-weight: 500;
      font-size: 20px;
      margin-bottom: 40px;
      cursor: pointer;
      white-space: nowrap;
    }

    .pj_item {
      border-bottom: 1px solid #DCDCDC;
      padding-bottom: 16px;
      margin-bottom: 16px;

      .pj_name {
        font-weight: 600;
        font-size: 20px;
        //margin-bottom: 16px;
      }
    }
  }

  .xm {
    height: 128px;
    background: #FFFFFF;
    border: 1px solid #DCDCDC;
    justify-content: start;
    overflow: hidden;
    margin-bottom: 25px;

    .xm_t {
      min-width: 217px;
      width: 217px;
      height: 128px;
      line-height: 128px;
      text-align: center;
      background: url("../../assets/image/venue/bg.png");
      background-size: 100%;
      font-size: 32px;
      color: #FFFFFF;
    }

    .xm_r {
      width: calc(100% - 217px);
      height: 100%;
      display: flex;
      overflow-x: auto;
      align-items: center;
      padding: 0 25px;
    }

    .xm_i {
      min-width: 96px;
      width: 96px;
      height: 96px;
      border-radius: 8px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 15px;
      cursor: pointer;
      margin-right: 80px;
      padding: 5px;

      .img_block {
        height: 30px;
        margin-bottom: 12px;
      }

      .item_block {
        text-align: center;
      }

      img {
        width: 30px;
        height: 30px;
      }
    }

    .sel_xm {
      background: #0058a61a;
    }
  }

  .xm_title {
    font-weight: 500;
    font-size: 24px;
    color: #0058A6;
    margin-bottom: 18px;
  }

  .xm_js {
    font-size: 18px;
    margin-bottom: 50px;
  }

  .rq {
    justify-content: start;
    margin-bottom: 25px;

    .rq_t {
      font-size: 18px;
      margin-right: 50px;
      width: 100px;
    }

    .rq_list {
      flex-wrap: wrap;
      justify-content: start;
    }

    .date_item {
      width: 192px;
      height: 52px;
      line-height: 52px;
      border-radius: 26px;
      text-align: center;
      font-size: 18px;
      cursor: pointer;
      margin-right: 20px;
    }

    .sel_date {
      background: #025AA7;
      color: #FFFFFF;
    }
  }

  .cd {
    display: flex;
    margin-bottom: 40px;

    .cd_left {
      width: calc(60% - 24px);
      padding: 30px;
      background: #F8F8F8;
      overflow: auto;
      display: flex;
      font-size: 18px;

      .cd_list {
        width: 80px;

        .cd_item {
          width: 90px;
          height: 50px;
          margin-bottom: 20px;
        }

        .t_item {
          margin-bottom: 0;
          height: 35px;
        }

        .date_item {
          line-height: 50px;
          background: #E1E1E1;
          border-radius: 4px;
          cursor: no-drop;
        }

        .kx_item {
          background: #FFFFFF;
          border: 1px solid #B0B0B0;
          cursor: pointer;
        }

        .sel_item {
          background: #0058A6;
          color: #ffffff;
          border: none;
        }
      }

      .r_list {
        text-align: center;
        margin-right: 47px;
      }
    }

    .cd_right {
      margin-left: 24px;
      width: 40%;
      background: #FFFFFF;
      border: 1px solid #DCDCDC;
      padding: 30px 24px;
      position: relative;
      min-height: 830px;

      .ts {
        justify-content: space-around;
        border-bottom: 1px solid #DCDCDC;
        padding-bottom: 30px;
        font-size: 18px;

        span {
          display: inline-block;
          width: 24px;
          height: 24px;
          border-radius: 2px;
          margin-right: 9px;
        }
      }

      .js {
        padding: 30px 0;
        border-bottom: 1px solid #DCDCDC;
        font-size: 18px;
      }

      .sel_cc {
        height: 450px;
        overflow-y: auto;
        padding: 30px 0;

        .cc_item {
          height: 64px;
          background: #0058a61a;
          border-radius: 4px;
          padding: 23px 25px;
          font-weight: 500;
          font-size: 18px;
          margin-bottom: 16px;

          i {
            color: #B0B0B0;
            cursor: pointer;
          }
        }

        .hj {
          font-weight: 500;
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: end;
          margin-top: 30px;

          div {
            color: #EC3535;
            display: flex;
            justify-content: center;
            align-items: end;

            span {
              font-size: 36px;
              line-height: 33px;
            }
          }
        }
      }

      .sub_btn {
        width: 288px;
        height: 56px;
        margin-top: 30px;
        position: absolute;
        left: 50%;
        bottom: 30px;
        transform: translateX(-50%);
      }
    }
  }
}

.dialog_content {
  height: 600px;
  width: 100%;
  position: relative;
}

.map {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.geography_style {
  width: 100%;
  height: 250px;
  position: relative;
}
</style>
